import { Button } from "@/components/ui/button";
import { List, Calendar } from "lucide-react";
import { useHaptics } from "@/hooks/useHaptics";

interface ViewToggleProps {
  view: 'list' | 'calendar';
  onViewChange: (view: 'list' | 'calendar') => void;
}

export const ViewToggle = ({ view, onViewChange }: ViewToggleProps) => {
  const { lightTap } = useHaptics();

  const handleViewChange = (newView: 'list' | 'calendar') => {
    if (newView !== view) {
      lightTap();
      onViewChange(newView);
    }
  };

  return (
    <div 
      className="flex gap-2 px-6 py-3 relative"
      role="tablist"
      aria-label="View toggle"
    >
      {/* Sliding background indicator */}
      <div
        className="absolute top-3 bottom-3 w-[calc(50%-0.5rem)] bg-primary rounded-md transition-transform duration-200 ease-out shadow-sm"
        style={{
          transform: view === 'list' ? 'translateX(0)' : 'translateX(calc(100% + 0.5rem))',
          left: '1.5rem',
        }}
        aria-hidden="true"
      />
      
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleViewChange('list')}
        className={`flex-1 relative z-10 transition-colors duration-200 min-h-[44px] ${
          view === 'list' 
            ? 'text-primary-foreground hover:text-primary-foreground hover:bg-transparent' 
            : 'text-muted-foreground hover:text-foreground hover:bg-transparent'
        }`}
        role="tab"
        aria-selected={view === 'list'}
        aria-controls="events-list-panel"
      >
        <List className="h-4 w-4 mr-2" />
        List
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => handleViewChange('calendar')}
        className={`flex-1 relative z-10 transition-colors duration-200 min-h-[44px] ${
          view === 'calendar' 
            ? 'text-primary-foreground hover:text-primary-foreground hover:bg-transparent' 
            : 'text-muted-foreground hover:text-foreground hover:bg-transparent'
        }`}
        role="tab"
        aria-selected={view === 'calendar'}
        aria-controls="events-calendar-panel"
      >
        <Calendar className="h-4 w-4 mr-2" />
        Calendar
      </Button>
    </div>
  );
};
